export default __webpack_public_path__ + "static/media/six.b830e73f.jpg";